import * as React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { Provider } from "react-redux";
import { Store } from "redux";
import configureStore from "../store/configureStore";
import initialState from "../store/initialState";
import { StoreState } from "../store/storeState";

export const store: Store<StoreState> = configureStore(initialState);

interface ProviderProps {
  children: JSX.Element;
}

export default (props: ProviderProps) => (
  <>
    <CssBaseline />
    <Provider store={store}>{props.children}</Provider>
  </>
);

// We can do some interesting prop/data injection using various
// rendering patterns
// https://medium.com/@jrwebdev/react-render-props-in-typescript-b561b00bc67c
